import { sendGAEvent } from "~/src/logic/GoogleAnalyticsLogic";

export const sendGAdsConversion = () => {
  sendGAEvent('conversion', {
    'send_to': 'AW-16842699709/hrVYCP3v8bQaEL3nnN8-'
  });
}
